module.exports = __webpack_public_path__ + "img/alert-circle-pink-filled.743f63a3.svg";